/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "tl3nSfAO5c8",
    title: "Awesome Sniper Stealth Gameplay from FPS Game",
    creator: "Best War Games Channel",
    category: "FPS",
    date: "1 year ago",
    views: "251k views",
    cover: "https://i.ytimg.com/vi/tl3nSfAO5c8/hq720.jpg",
    url: "https://www.youtube.com/watch?v=tl3nSfAO5c8"
  },
  {
    _id: "OECS9Gg2iOg",
    title: "Top 25 Best Third-person Shooter PC Games",
    creator: "whatoplay",
    category: "TPS",
    date: "3 years ago",
    views: "1.5M views",
    cover: "https://i.ytimg.com/vi/OECS9Gg2iOg/hq720.jpg",
    url: "https://www.youtube.com/watch?v=OECS9Gg2iOg"
  },
  {
    _id: "_JZsfpphljo",
    title: "Top 10 BEST RPGs of 2021 [4K] PC Gaming",
    creator: "Gameranx",
    category: "RPG",
    date: "5 years ago",
    views: "115k views",
    cover: "https://i.ytimg.com/vi/_JZsfpphljo/hq720.jpg",
    url: "https://www.youtube.com/watch?v=_JZsfpphljo"
  },
  {
    _id: "Zw8XmS5tc0w",
    title: "TOP 25 ACTION ADVENTURE GAMES PC || 2011-2021",
    creator: "Game Room",
    category: "Action-Adventure",
    date: "4 years ago",
    views: "3K views",
    cover: "https://i.ytimg.com/vi/Zw8XmS5tc0w/hq720.jpg",
    url: "https://www.youtube.com/watch?v=Zw8XmS5tc0w"
  },
  {
    _id: "2_9FToybfIY",
    title: "Top 10 Real Time Strategy Games",
    creator: "WatchMojo.com",
    category: "Real-time strategy",
    date: "1 year ago",
    views: "242k views",
    cover: "https://i.ytimg.com/vi/2_9FToybfIY/hq720.jpg",
    url: "https://www.youtube.com/watch?v=2_9FToybfIY"
  },
  {
    _id: "HwV12XfCnPg",
    title: "Top 20 NEW Third Person Games of 2020",
    creator: "Gameranx",
    category: "TPS",
    date: "1 year ago",
    views: "242k views",
    cover: "https://i.ytimg.com/vi/HwV12XfCnPg/hq720.jpg",
    url: "https://www.youtube.com/watch?v=HwV12XfCnPg"
  },
  {
    _id: "NDKfb6-9SVE",
    title: "The Top 10 Best Modern RPGs of the Last 15 Years",
    creator: "IGN",
    category: "RPG",
    date: "1 year ago",
    views: "242k views",
    cover: "https://i.ytimg.com/vi/NDKfb6-9SVE/hqdefault.jpg",
    url: "https://www.youtube.com/watch?v=NDKfb6-9SVE"
  },
  {
    _id: "OHgCYYVUcqU",
    title: "Best RTS Games 2021 | TOP10 Real Time Strategy PC Games",
    creator: "NoChatBot",
    category: "Real-time strategy",
    date: "1 year ago",
    views: "242k views",
    cover: "https://i.ytimg.com/vi/OHgCYYVUcqU/hq720.jpg",
    url: "https://www.youtube.com/watch?v=OHgCYYVUcqU"
  }
];
